/**
 * Camadas WMS públicas de contexto ambiental.
 * Entram como fundo consultável — sem PostGIS.
 */
export const MAP_OVERLAYS = [
  {
    id: 'uc',
    label: 'Unidades de conservação (ICMBio)',
    url: 'https://geoservicos.icmbio.gov.br/geoserver/publico/ows',
    params: { LAYERS: 'publico:cnuc', TILED: true, VERSION: '1.1.1' },
  },
  {
    id: 'car',
    label: 'CAR / SICAR',
    url: 'https://geoserver.car.gov.br/geoserver/sicar/ows',
    params: { LAYERS: 'sicar:sicar_imoveis', TILED: true, VERSION: '1.1.1' },
  },
  {
    id: 'app',
    label: 'APP / áreas protegidas (IBAMA)',
    url: 'https://geoservicos.ibama.gov.br/geoserver/publico/ows',
    params: { LAYERS: 'publico:area_app', TILED: true, VERSION: '1.1.1' },
  },
  {
    id: 'hidro',
    label: 'Hidrografia (IBGE)',
    url: 'https://geoservicos.ibge.gov.br/geoserver/ows',
    params: { LAYERS: 'CCAR:BC250_Trecho_Drenagem_L', TILED: true, VERSION: '1.1.1' },
  },
  {
    id: 'zoneamento',
    label: 'Limites municipais (IBGE)',
    url: 'https://geoservicos.ibge.gov.br/geoserver/ows',
    params: { LAYERS: 'CGEO:LIM_Municipio_A', TILED: true, VERSION: '1.1.1' },
  },
];

export function overlayById(id) {
  return MAP_OVERLAYS.find((layer) => layer.id === id) || null;
}
